<script>
	export let data;

	import { cloneDeep } from "lodash-es";
	import { fade, scale } from "svelte/transition";

	import { profileData } from "../../../../stores/data";
	import { customAlert } from "../../../../scripts/custom_alert";
	import { request } from "../../../../scripts/request";
	import { localUrl } from "../../../../scripts/is_local";
	import { checkRequire } from "../../../../scripts/form_validation";
	import { changeHash } from "../../../../scripts/change_hash";
	// requestHash
	import { getNoun } from "../../../../scripts/get_noun";

	import {
		isMobile,
		saved,
		changed,
		isNewDataChanged,
		specialistsIDs,
		specialistsAddArr,
		SpecialistPremodDone,
		currentHash,
		currentEntityID,
	} from "../../../../stores/variables";

	import Input from "./form_modal/Input.svelte";
	import Inputs from "../simple/Inputs.svelte";
	import Textarea from "./form_modal/Textarea.svelte";
	import Image from "./form_modal/Image.svelte";
	import Ranks from "./form_modal/Ranks.svelte";
	import Specialities from "./form_modal/Specialities.svelte";
	// import AddToMoreClinics from "./form_modal/AddToMoreClinics.svelte";
	import Multiple from "./form_modal/Multiple.svelte";
	import { addNotify } from "../../../../scripts/notification";

	let componentList = [
		{
			ID: "Input",
			component: Input,
		},
		{
			ID: "Textarea",
			component: Textarea,
		},
		{
			ID: "Multiple",
			component: Multiple,
		},
		{
			ID: "Image",
			component: Image,
		},
		// {
		// 	ID: "AddToMoreClinics",
		// 	component: AddToMoreClinics,
		// },
		{
			ID: "Ranks",
			component: Ranks,
		},
		{
			ID: "Specialities",
			component: Specialities,
		},
	];

	let new_sp_id = 0;
	let form;
	let input;
	let currentYear = new Date().getFullYear();

	function handleFindResult(result) {
		if (result.length > 0) {
			data.result = result;
		} else {
			data.result = [
				{
					ID: 0,
					Name: "Ничего не найдено",
				},
			];
		}
	}
	async function handleFind(value) {
		const formData = new FormData();
		formData.append("q", value);
		formData.append("clinicID", +$currentEntityID);
		let r = request.getAjaxData(
			"custom/MedApi/Med_ajax_doctors_list.php",
			{ method: "POST", credentials: "omit", body: formData },
			"find_doctor"
		);
		r.then((result) => {
			handleFindResult(result);
		});
	}
	async function add_sp(i) {
		let temp = data.result.splice(i, 1);
		data.req_doctors.push(...temp);
		data = data;
		data.req_ids = [];
		data.req_doctors.forEach((doc) => {
			data.req_ids.push(doc.ID);
		});
		// data.result[i].active = true;
	}
	function dell_sp(i) {
		let temp_id = data.req_ids.splice(i, 1);
		let temp = data.req_doctors.splice(i, 1);
		let check;
		data.result.forEach((raw) => {
			if (raw.ID == temp_id) {
				check = true;
			}
		});
		if (!check) data.result.push(...temp);
		data = data;
	}
	async function find_doctors() {
		if (data.req_ids.length > 0) {
			$specialistsAddArr = data.req_doctors;
			let D = { id: 0, doc_ids: data.req_ids };
			D.id = +$currentEntityID;
			let r = request.fetchData("UpdateDoctors", "add_doctors", D, form);
			data.find_active = true;
			r.then((result) => {
				if (result.data == "premod_done") $SpecialistPremodDone = true;
				data.find_active = false;
				$specialistsIDs = $specialistsIDs.concat(data.req_ids);
				data.req_ids = [];
				data.req_doctors = [];
				data.popup = 1;
				if (result.id != +$currentEntityID) {
					changeHash("clinic", result.id);
				}
				location.reload();
			});
		}
	}
	async function add() {
		const confirm = await customAlert("Добавить специалиста?", [
			"Добавить нового специалиста",
			"Найти специалиста в базе данных",
		]);
		if (confirm) {
			if (confirm == "Найти специалиста в базе данных") {
				data.find = true;
			}
			if (confirm == "Добавить нового специалиста") {
				let temp = cloneDeep(data.template);
				let temp2 = {};
				temp.forEach((block) => {
					if (block.field_names) {
						block.field_names.forEach((raw) => {
							temp2[raw] = "";
						});
					}
				});
				temp2["ID"] = "0";
				temp.temp_id = "new_sp" + new_sp_id++;
				temp.active = 1;
				temp2.temp_id = temp.temp_id;
				temp.name = "Добавить специалиста";
				if (!data[data.field_name + "_new"])
					data[data.field_name + "_new"] = [];
				data[data.field_name + "_new"].push(temp);
				data.createdData.push(temp2);
				data = data;
			}
		} else {
			return;
		}
	}
	function undelete_sp_old(index) {
		data.loadedData[index]["ToDelete"] = false;
		if (!data.loadedData[index]["toUpdate"]) {
			if (data.newData[data.field_name]) {
				data.newData[data.field_name].forEach((specialist, i) => {
					if (specialist["ID"] == data.loadedData[index]["ID"]) {
						data.newData[data.field_name].splice(i, 1);
						data = data;
					}
				});
			}
		}
	}
	function delete_sp_old(index) {
		let check = false;
		data.loadedData[index]["ToDelete"] = true;
		data[data.field_name][index].active = false;
		data.newData[data.field_name].forEach((new_sp) => {
			if (new_sp["ID"] == data.loadedData[index]["ID"]) check = true;
		});
		if (!check) {
			data.newData[data.field_name].push(data.loadedData[index]);
			check = false;
		}
		$isNewDataChanged = true;
	}
	function delete_sp_new(index) {
		data[data.field_name + "_new"][index].deleted = true;
		data.newData[data.field_name].forEach((new_sp, i) => {
			if (
				new_sp.temp_id == data[data.field_name + "_new"][index].temp_id
			) {
				data.newData[data.field_name].splice(i, 1);
				data = data;
			}
		});
	}
	async function cancel_sp_new(index) {
		if ($changed) {
			let alert = await customAlert("Выйти без сохранения?");
			if (alert) {
				$saved = "canceled";
				setTimeout(() => {
					$saved = "";
					data[data.field_name + "_new"][index].active = false;
					$changed = "";
				}, 0);
			}
		} else {
			$saved = "canceled";
			setTimeout(() => {
				$saved = "";
				data[data.field_name + "_new"][index].active = false;
			}, 0);
		}
	}
	function save_sp_new(index) {
		$saved = "saved";
		setTimeout(() => {
			data[data.field_name + "_new"][index].active = false;
			$changed = "";
			$saved = "";
		}, 0);
	}
	async function cancel_sp(index) {
		if ($changed) {
			let alert = await customAlert("Выйти без сохранения?");
			if (alert) {
				$saved = "canceled";
				setTimeout(() => {
					$saved = "";
					data[data.field_name][index].active = false;
					$changed = "";
				}, 0);
			}
		} else {
			$saved = "canceled";
			setTimeout(() => {
				$saved = "";
				data[data.field_name][index].active = false;
			}, 0);
		}
	}
	function save_sp(index) {
		$saved = "saved";
		setTimeout(() => {
			data[data.field_name][index].active = false;
			$changed = "";
			$saved = "";
		}, 0);
	}
	function req_null() {
		data.find = "";
		data.result = [];
		input.value = "";
		data.req_ids = [];
		data.req_doctors = [];
		request.getAjaxData("", { credentials: "omit" }, "find_doctor");
	}
	async function handeCloseFind() {
		if (data.req_ids.length > 0) {
			let temp = await customAlert("Закрыть без сохранения?");
			if (temp) {
				req_null();
			}
		} else {
			req_null();
		}
	}

	if (data) {
		if (!data.template) {
			data.template = [
				{
					ID: "Input",
					name: "Специалист",
					field_names: ["Name"],
					field_name: "Name",
					placeholder: "ФИО",
					value: "",
				},
				{
					ID: "Specialities",
					name: "Специальность",
					field_names: ["Specialities"],
					field_name: "Specialities",
					value: "",
				},
				{
					ID: "Textarea",
					name: "Описание",
					field_names: ["Text"],
					field_name: "Text",
				},
				{
					ID: "Input",
					type: "number",
					name: "Год начала работы",
					field_names: ["Started"],
					field_name: "Started",
					maxlength: 4,
				},
				{
					ID: "Image",
					name: "Фото",
					field_names: ["Image"],
					field_name: "Image",
				},
				{
					ID: "Ranks",
					name: "Регалии",
					field_names: ["Ranks"],
					field_name: "Ranks",
				},
				{
					ID: "Multiple",
					name: "Образование",
					field_names: ["Education"],
					field_name: "Education",
				},
				{
					ID: "Multiple",
					name: "Квалификация",
					field_names: ["Qualification"],
					field_name: "Qualification",
				},
				{
					ID: "Multiple",
					name: "Сертификаты",
					field_names: ["Certification"],
					field_name: "Certification",
				},
				{
					ID: "Multiple",
					name: "Публикации",
					field_names: ["Publications"],
					field_name: "Publications",
				},
				{
					ID: "Multiple",
					name: "Активности",
					field_names: ["Activities"],
					field_name: "Activities",
				},
				{
					ID: "Multiple",
					name: "Стаж",
					field_names: ["Job"],
					field_name: "Job",
				},
			];
		}

		if (!data[data.field_name]) data[data.field_name] = [];
		if (!data.loadedData) data.loadedData = [];
		if (!data.createdData) data.createdData = [];
		if (!data.req_doctors) data.req_doctors = [];
		if (!data.req_ids) data.req_ids = [];
		if (!data.newData) data.newData = [];
		if (!data.newData[data.field_name]) data.newData[data.field_name] = [];

		if (data.newData) {
			if (data.newData[data.field_name]) {
				data.loadedData = data.newData[data.field_name];
				data.newData[data.field_name] = [];
				data.loadedData.forEach((specialist) => {
					$specialistsIDs.push(specialist.ID);
					let temp = cloneDeep(data.template);
					temp.forEach((block) => {
						if (!block.newData) block.newData = [];
						if (block.field_names) {
							block.field_names.forEach((raw) => {
								block.newData[raw] = specialist[raw];
							});
						}
					});
					temp.name = "Редактировать специалиста";
					data[data.field_name].push(temp);
				});
			}
		}
	}
	$: if (
		data &&
		data.newData &&
		data.newData[data.field_name] &&
		Array.isArray(data.newData[data.field_name]) &&
		data.newData[data.field_name].length < 1
	) {
		$isNewDataChanged = false;
	}

	let inputsData = {
		field_names: ["Name", "Phone"],
		name: "Введите Ваши данные",
		maxlength: 255,
		inputs: [
			{
				description: "Ваше имя",
				value: "",
				field_name: "Name",
				type: "text",
				required: true,
			},
			{
				description: "Ваш номер телефона",
				value: "",
				field_name: "Phone",
				type: "phone",
				required: true,
			},
		],
		newData: [],
	};
	if ($profileData) {
		if ($profileData.PhoneFormatted)
			inputsData.newData["Phone"] = $profileData.PhoneFormatted;
		if ($profileData.FullName)
			inputsData.newData["Name"] = $profileData.FullName;
	}
	let requestModal = false;
	let requestData = {
		data: {
			chat_id: -649990333,
			bottoken: "5252026062:AAEGAdmu0xKNwUxuWN-XShm9DsaLshYCi9s",
		},
	};
	function handleClose() {
		requestModal = false;
		requestData = {
			data: {
				chat_id: -649990333,
				bottoken: "",
			},
		};
	}
	function promoteDoctor(doctor) {
		requestModal = !requestModal;
		requestData.data.doctor = doctor["ID"];
		requestData.data.clinic = +$currentEntityID;
	}
	function handleSend() {
		let doc_id = requestData.data.doctor;
		if (!checkRequire(form)) return;
		inputsData.field_names.forEach((raw) => {
			requestData.data[raw] = inputsData.newData[raw];
		});
		request
			.fetchData(
				"Med_ajax_request_add_doctor_to_clinic.php",
				"add_doctor_to_clinic",
				requestData,
				{ path: "custom/MedApi/", credentials: "omit" }
			)
			.then(() => {
				let text = "Заявка успешно отправлена";
				addNotify(text, "ok");
				data.loadedData.forEach((doctor, i) => {
					if (doc_id == doctor["ID"]) {
						data.loadedData[i]["clicked"] = true;
					}
				});
			})
			.catch((error) => {
				addNotify(error, "error");
			});
		handleClose();
	}
</script>

<div class="modal" class:active={requestModal}>
	<div
		class="modal__bg"
		on:click={() => {
			handleClose();
		}}
	/>
	<form class="modal__body" bind:this={form}>
		<i
			class="fas fa-times modal__cross"
			on:click={() => {
				handleClose();
			}}
		/>
		<span class="modal__title"
			>Запросить права на редактирование специалиста</span
		>
		<div
			class="modal__content scrollbar-white {$isMobile
				? 'mobile'
				: 'not_mobile'}"
		>
			<div>
				<svelte:component
					this={Inputs}
					noNeedToChange={true}
					data={inputsData}
				/>
			</div>
		</div>
		<div class="modal__buttons">
			<span
				class="modal__button modal__save"
				on:click={() => {
					handleSend();
				}}>Ок</span
			>
			<span
				class="modal__button modal__cancel"
				on:click={() => {
					handleClose();
				}}>Отмена</span
			>
		</div>
	</form>
</div>

{#if data}
	<!-- {#if data.popup}
		<div class="popup" class:active={data.popup} transition:fade>
			<div class="popup__bg" on:click={() => (data.popup = "")} />
			<div class="popup__body">
				<i
					class="fas fa-times popup__cross"
					on:click={() => (data.popup = "")}
				/>
				<b>Данные успешно сохранены!</b>
				<span
					>История <b on:click={() => link()} style="cursor: pointer;"
						>заявок</b
					></span
				>
			</div>
		</div>
	{/if} -->

	<div class="specialists">
		<div class="modal specialists__find {data.find ? 'active' : ''}">
			<div class="modal__bg" on:click={handeCloseFind} />
			<div class="modal__body">
				<i
					class="modal__cross fas fa-times"
					on:click={handeCloseFind}
				/>
				<span class="modal__title">Поиск специалиста</span>
				<div
					class="modal__content scrollbar-white {$isMobile
						? 'mobile'
						: 'not_mobile'} find"
				>
					<label class="find__input">
						<input
							type="text"
							placeholder="Имя специалиста"
							bind:this={input}
							on:input={(e) => {
								if (e.target.value.length > 2) {
									handleFind(e.target.value);
								} else {
									data.result = [];
								}
							}}
						/>
					</label>
					{#if data.result}
						<ul class="find__list">
							{#each data.result as { ID, Name, Image, active }, i}
								{#if data.req_ids && !data.req_ids.includes(ID) && !$specialistsIDs.includes(ID)}
									<li
										class="find__item {ID == 0
											? 'blank'
											: ''}"
										transition:fade
									>
										{#if Image}
											<div class="find__img">
												<img
													src={localUrl(
														"https://topdent.ru",
														Image
													)}
													alt=""
												/>
											</div>
										{/if}
										{#if Name}
											<span class="find__name"
												>{Name}</span
											>
										{/if}
										{#if ID != 0}
											<span
												class="find__button button"
												on:click={() => add_sp(i)}
											>
												{#if active}
													<div
														class="button__loading"
														transition:fade
													>
														<div
															class="button__spinner"
														/>
													</div>
												{/if}
												Добавить
											</span>
										{/if}
									</li>
								{/if}
							{/each}
							{#if data.req_doctors && data.req_doctors.length > 0}
								<span class="find__spacer"
									>Выбранные врачи:</span
								>
								{#each data.req_doctors as { ID, Name, Image, active }, i}
									<li
										class="find__item new{ID == 0
											? 'blank'
											: ''}"
										transition:fade
									>
										{#if Image}
											<div class="find__img">
												<img
													src={localUrl(
														"https://topdent.ru",
														Image
													)}
													alt=""
												/>
											</div>
										{/if}
										{#if Name}
											<span class="find__name"
												>{Name}</span
											>
										{/if}
										{#if ID != 0}
											<span
												class="find__button button"
												on:click={() => dell_sp(i)}
											>
												{#if active}
													<div
														class="button__loading"
														transition:fade
													>
														<div
															class="button__spinner"
														/>
													</div>
												{/if}
												Удалить
											</span>
										{/if}
									</li>
								{/each}
							{/if}
						</ul>
					{/if}
					<!-- {#if data.req_doctors && data.req_doctors.length > 0}
					{/if} -->
				</div>
				<div
					class="find__add"
					class:active={data.req_doctors &&
						data.req_doctors.length > 0}
				>
					<span class="find__add-btn" on:click={() => find_doctors()}>
						{#if data.find_active}
							<div class="button__loading" transition:fade>
								<div class="button__spinner" />
							</div>
						{/if}
						Добавить врачей</span
					>
					<span class="find__add-counter"
						>{getNoun(
							data.req_doctors.length,
							"Выбран",
							"Выбрано",
							"Выбрано"
						)}
						{data.req_doctors.length}
						{getNoun(
							data.req_doctors.length,
							"врач",
							"врача",
							"врачей"
						)}</span
					>
				</div>
			</div>
		</div>

		{#if data[data.field_name]}
			{#each data[data.field_name] as specialist, index}
				<div
					class="specialists__item specialist {data.loadedData[index][
						'ToDelete'
					]
						? 'deleted'
						: ''}"
				>
					{#if data.loadedData[index]["ToDelete"]}
						<div class="specialist__bg" />
					{/if}

					<div class="modal" class:active={specialist.active}>
						<div
							class="modal__bg"
							on:click={() => {
								cancel_sp(index);
							}}
						/>
						<div class="modal__body">
							<i
								class="fas fa-times modal__cross"
								on:click={() => {
									cancel_sp(index);
								}}
							/>
							{#if specialist.name}
								<span class="modal__title"
									>{specialist.name}</span
								>
							{/if}
							<div
								class="modal__content scrollbar-white {$isMobile
									? 'mobile'
									: 'not_mobile'}"
							>
								{#each specialist as block, j}
									{#each componentList as component}
										{#if block.ID == component.ID}
											<div class="modal__item">
												<svelte:component
													this={component.component}
													{block}
													{data}
													{index}
													{j}
													type={""}
												/>
											</div>
										{/if}
									{/each}
								{/each}
							</div>
							<div class="modal__buttons">
								<span
									class="modal__button modal__save"
									on:click={() => {
										save_sp(index);
									}}>Ок</span
								>
								<span
									class="modal__button modal__cancel"
									on:click={() => {
										cancel_sp(index);
									}}>Отмена</span
								>
								<span
									class="modal__button modal__delete"
									on:click={() => {
										delete_sp_old(index);
									}}>Удалить</span
								>
							</div>
						</div>
					</div>

					<div class="specialist__preview">
						{#if data.loadedData[index]["Image"]}
							<div class="specialist__img">
								<img
									src={localUrl(
										"https://topdent.ru",
										data.loadedData[index]["Image"]
									)}
									alt=""
								/>
								{#if data.loadedData[index]["Rating"] && data.loadedData[index]["Rating"] != "0.00"}
									<span class="specialist__rating"
										><i class="fas fa-star" />{data
											.loadedData[index]["Rating"]}</span
									>
								{/if}
							</div>
						{:else}
							<div
								class="specialist__img specialist__img-blank"
							/>
						{/if}
						<div class="specialist__content">
							{#if data.loadedData[index]["ToDelete"]}
								<i
									class="fas fa-check specialist__check"
									on:click={() => {
										undelete_sp_old(index);
									}}
								/>
							{:else}
								<i
									class="fas fa-trash specialist__delete"
									on:click={() => {
										delete_sp_old(index);
									}}
								/>
							{/if}
							{#if data.loadedData[index]["Name"]}
								<div class="specialist__name">
									<span>{data.loadedData[index]["Name"]}</span
									>
								</div>
							{/if}
							{#if data.loadedData[index]["Started"]}
								<span class="specialist__standing"
									>{"Стаж " +
										(currentYear -
											data.loadedData[index]["Started"]) +
										" " +
										getNoun(
											currentYear -
												data.loadedData[index][
													"Started"
												],
											"год",
											"года",
											"лет"
										)}</span
								>
							{/if}
							{#if data.loadedData[index]["Can"]}
								<div
									class="specialist__button"
									on:click|preventDefault={() =>
										(specialist.active = "1")}
								>
									<span>Редактировать</span>
								</div>
							{:else if !data.loadedData[index]["clicked"]}
								<div
									class="specialist__button request"
									on:click={() => {
										promoteDoctor(data.loadedData[index]);
									}}
								>
									<span
										>Запросить права на редактирование</span
									>
								</div>
							{:else}
								<div
									class="specialist__button request"
									style="cursor: auto"
								>
									<span>Права запрошены</span>
								</div>
							{/if}
						</div>
					</div>
				</div>
			{/each}
		{/if}
		{#if data[data.field_name + "_new"]}
			{#each data[data.field_name + "_new"] as specialist, index}
				<div
					class="specialists__item specialist {specialist.deleted
						? 'new_deleted'
						: ''}"
				>
					<div class="modal" class:active={specialist.active}>
						<div
							class="modal__bg"
							on:click={() => {
								cancel_sp_new(index);
							}}
						/>
						<div class="modal__body">
							<i
								class="fas fa-times modal__cross"
								on:click={() => {
									cancel_sp_new(index);
								}}
							/>
							{#if specialist.name}
								<span class="modal__title"
									>{specialist.name}</span
								>
							{/if}
							<div
								class="modal__content scrollbar-white {$isMobile
									? 'mobile'
									: 'not_mobile'}"
							>
								{#each specialist as block, j}
									{#each componentList as component}
										{#if block.ID == component.ID}
											<div class="modal__item">
												<svelte:component
													this={component.component}
													{block}
													{data}
													{index}
													{j}
													type={"new"}
												/>
											</div>
										{/if}
									{/each}
								{/each}
							</div>
							<div class="modal__buttons">
								<span
									class="modal__button modal__save"
									on:click={() => {
										save_sp_new(index);
									}}>Ок</span
								>
								<span
									class="modal__button modal__cancel"
									on:click={() => {
										cancel_sp_new(index);
									}}>Отмена</span
								>
								<span
									class="modal__button modal__delete"
									on:click={() => {
										delete_sp_new(index);
									}}>Удалить</span
								>
							</div>
						</div>
					</div>

					<div class="specialist__preview">
						{#if data.createdData[index]["Image"]}
							<div class="specialist__img">
								<img
									src={localUrl(
										"https://topdent.ru",
										data.createdData[index]["Image"]
									)}
									alt=""
								/>
							</div>
						{:else}
							<div
								class="specialist__img specialist__img-blank"
							/>
						{/if}
						<div class="specialist__content">
							<i
								class="fas fa-trash specialist__delete"
								on:click={() => {
									delete_sp_new(index);
								}}
							/>

							{#if data.createdData[index]["Name"]}
								<div class="specialist__name">
									<span
										>{data.createdData[index]["Name"]}</span
									>
								</div>
							{/if}
							{#if data.createdData[index]["Started"]}
								<span class="specialist__standing"
									>{"Стаж " +
										(currentYear -
											data.createdData[index][
												"Started"
											]) +
										" " +
										getNoun(
											currentYear -
												data.createdData[index][
													"Started"
												],
											"год",
											"года",
											"лет"
										)}</span
								>
							{/if}

							<div
								class="specialist__button"
								on:click|preventDefault={() =>
									(specialist.active = "1")}
							>
								<span>Редактировать</span>
							</div>
						</div>
					</div>
				</div>
			{/each}
		{/if}
		<div
			class="specialists__template simple-modal {$isMobile
				? 'mobile'
				: 'not_mobile'}"
		>
			<div class="template" on:click={() => add()}>
				<span><i /></span>
			</div>
		</div>
	</div>
{/if}

<style lang="scss">
	.button {
		display: flex;
		position: relative;
		overflow: hidden;
		&__loading {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: #000000b8;
			display: flex;
			align-items: center;
			justify-self: center;
		}
		&__spinner {
			position: absolute;
			height: 18px;
			width: 18px;
			border: 3px solid transparent;
			border-top-color: var(--color-1);
			left: calc(50% - 12px);
			border-radius: 50%;
			animation: spin 2s linear infinite;
			&:before,
			&:after {
				content: "";
				position: absolute;
				border: 3px solid transparent;
				border-radius: 50%;
			}
			&:before {
				border-top-color: var(--color-1);
				top: -12px;
				left: -12px;
				right: -12px;
				bottom: -12px;
				animation: spin 3s linear infinite;
			}
			&:after {
				border-top-color: var(--color-1);
				top: 6px;
				left: 6px;
				right: 6px;
				bottom: 6px;
				animation: spin 4s linear infinite;
			}
		}
	}
	.popup {
		position: fixed;
		z-index: 1001;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: auto;

		&__bg {
			cursor: pointer;
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			background-color: #00000066;
			z-index: -1;
		}

		&__cross {
			position: absolute;
			cursor: pointer;
			top: 18px;
			right: 18px;
			font-size: 20px;
		}

		&__body {
			background: var(--bg-main-1);
			position: relative;
			border-radius: 16px;
			margin: 0 30px;
			overflow: hidden;
			display: flex;
			max-height: 80vh;
			max-width: 80vw;
			padding: 30px;
			flex-direction: column;
			> b {
				font-size: 20px;
				margin-right: 20px;
			}
			> span {
				margin-top: 16px;
				font-size: 16px;
				&:first-child {
					margin-bottom: 12px;
				}
				> b {
					color: var(--color-1);
				}
			}
		}
	}

	.find {
		&__input {
			width: 100%;
			display: flex;
			align-items: stretch;
			border: solid 1px var(--border-gray-1);
			padding: 10px 20px;
			margin-bottom: 20px;
			border-radius: 16px;
			transition: border-color 0.1s ease;
			&:hover,
			&:focus,
			&:focus-within {
				border-color: var(--color-1);
			}
			> input {
				width: 100%;
				outline: none;
				border: none;
			}
		}
		&__list {
			display: flex;
			flex-direction: column;
		}
		&__item {
			display: flex;
			align-items: center;
			padding: 15px 30px;
			margin: 0 -30px;

			&:hover {
				background-color: #f8f9fe;
			}
			&.new {
				background-color: #f3f3f3;
				&:hover {
					background-color: #f3f3f3;
				}
			}
		}
		&__spacer {
			display: flex;
			font-size: 20px;
			font-weight: bold;
			line-height: 28px;
			color: var(--bg-black-1);
			background: #f3f3f3;
			margin: 0 -30px;
			padding: 15px 30px 5px;
		}
		&__img {
			height: 40px;
			width: 40px;
			border-radius: 50%;
			overflow: hidden;
			margin-right: 16px;
			flex-shrink: 0;
			> img {
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
		}
		&__button {
			position: relative;
			padding: 8px 20px;
			color: var(--color-1);
			border: 1px solid var(--color-1);
			border-radius: 50px;
			background: var(--bg-main-1);
			font-weight: 400;
			cursor: pointer;
			margin-left: auto;
			flex-shrink: 0;
			@media (max-width: 767px) {
				padding: 8px 10px;
				font-size: 12px;
			}
		}
		&__add {
			background-color: #fff;
			padding: 15px 30px;
			display: flex;
			flex-shrink: 0;
			margin-top: auto;
			align-items: center;
			&-btn {
				display: flex;
				align-self: flex-start;
				border-radius: 8px;
				width: 180px;
				align-items: center;
				justify-content: center;
				padding: 10px 0;
				background-color: #efefef;
				color: var(--text-black);
			}
			&-counter {
				font-size: 14px;
				color: gray;
				margin-left: 15px;
			}
			&.active {
				.find__add-btn {
					background-color: var(--color-1);
					color: var(--text-main-1);
					cursor: pointer;
				}
			}
		}
	}
	.template {
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--color-1);
		border-radius: 20px;
		cursor: pointer;
		flex-grow: 1;

		> span {
			height: 50px;
			width: 50px;
			border-radius: 50%;
			border: solid 5px #fff;

			> i {
				height: 100%;
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;

				&::before,
				&::after {
					content: "";
					height: 50%;
					width: 5px;
					background-color: #fff;
				}

				&::after {
					transform: rotate(90deg);
					margin-left: -5px;
				}
			}
		}
	}
	.specialists {
		max-width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin: 0 -20px -20px 0;

		@media (max-width: 991px) {
			flex-direction: column;
		}

		&__find {
			.modal__body {
				max-width: 560px !important;
			}
		}

		&__item,
		&__template {
			display: flex;
			min-height: 152px;
			flex-shrink: 0;
			flex-basis: calc(50% - 20px);
			border-radius: 20px;
			margin: 0 20px 20px 0;

			@media (max-width: 991px) {
				flex-basis: unset;
				margin: 0 0 20px 0;
			}
		}
		&__item {
			box-shadow: rgba(61, 63, 85, 0.396) 0px 0px 1px,
				rgba(61, 63, 85, 0.047) 0px 2px 15px;

			&.new_deleted {
				display: none;
			}
			.modal__content {
				padding: 0 !important;
			}
		}
		&__template {
			order: 10000;
			overflow: hidden;
		}
		.modal.specialists__find {
			.modal {
				&__body {
					display: flex !important;
					flex-direction: column !important;
					height: 100% !important;
					max-height: 80vh !important;
				}
				&__content {
					padding: 0 30px !important;
				}
				@media (max-width: 767px) {
					&__body {
						height: 100vh !important;
						max-height: inherit !important;
						margin: 0 !important;
						border-radius: 0 !important;
					}
					&__content {
						height: 100% !important;
						max-height: 100% !important;
					}
				}
			}
		}
	}
	.specialist {
		padding: 16px 12px 18px 12px;
		overflow: hidden;
		max-width: 100%;

		@media (max-width: 700px) {
			padding: 10px 8px;
		}

		transition: background-color 0.1s ease-in;
		&:hover {
			background-color: #f9fafb;
		}
		&.deleted {
			position: relative;
			overflow: hidden;
			border: solid 1px var(--color-4);
			.specialist {
				&__bg {
					position: absolute;
					top: 0;
					left: 0;
					bottom: 0;
					right: 0;
					background: #ff00001c;
					display: flex;
					align-items: center;
					justify-content: center;
					z-index: 10;
					&::before,
					&::after {
						content: "";
						height: 100%;
						width: 2px;
						background: var(--color-4);
						display: flex;
						position: absolute;
					}
					&::before {
						transform: rotate(45deg);
					}
					&::after {
						transform: rotate(-45deg);
					}
				}
				&__check {
					z-index: 11;
					color: var(--color-4);
					&:hover {
						color: var(--color-1);
					}
				}
			}
		}

		&__delete,
		&__check {
			z-index: 100;
			position: absolute;
			right: 0;
			height: 0;
			width: 0;
			font-size: 10px;
			color: #979797;
			padding: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 8px;
			cursor: pointer;
			border: solid 1px #979797;
			&:hover {
				color: var(--color-1);
			}
		}

		&__rating {
			position: absolute;
			bottom: 0;
			right: 0;
			color: #ffaa30;
			font-size: 13px;
			line-height: 20px;
			padding: 4px;
			background: #fff;
			border-top-left-radius: 10px;
			font-size: 13px;
			font-weight: bold;

			> i {
				margin-right: 4px;
			}
		}

		&__img {
			display: flex;
			flex-shrink: 0;
			max-height: 110px;
			max-width: 110px;
			width: 100%;
			height: 100%;
			margin-right: 12px;
			align-self: flex-start;
			position: relative;

			@media (max-width: 700px) {
				max-height: 80px;
				max-width: 80px;
				position: absolute;
			}

			&-blank {
				border-radius: 20px;
				border: solid 1px var(--border-gray-1);
			}

			> img {
				object-fit: cover;
				width: 100%;
				height: 100%;
				border-radius: 20px;
			}
		}

		&__preview {
			display: flex;
			width: 100%;
		}

		&__content {
			display: flex;
			flex-grow: 1;
			flex-direction: column;
			position: relative;
		}

		&__name {
			font-size: 16px;
			font-weight: 700;
			line-height: 24px;
			padding-right: 32px;

			@media (max-width: 700px) {
				padding-left: 90px;
			}
		}

		&__standing {
			padding-right: 32px;
			@media (max-width: 700px) {
				padding-left: 90px;
			}
		}

		&__button {
			display: flex;
			cursor: pointer;
			margin: auto 0 0 auto;
			align-self: flex-start;
			order: 1000;
			padding: 16px 0 0 0;

			@media (max-width: 700px) {
				width: 100%;
				flex-direction: column;
			}

			> span {
				border-radius: 6px;
				text-align: center;
				background: var(--color-1);
				color: var(--text-main-1);
				font-size: 13px;
				padding: 6px 30px;
			}

			&.request {
				cursor: pointer;
				> span {
					background: #efefef;
					color: var(--text-black-1);
				}
			}
		}
	}
</style>
